export default __webpack_public_path__ + "static/media/Amount.0b888276.svg";